<template>
  <div class="home">
    <HelloWorld msg="Welcome to FireAds App" />
    <div class="login">
      <div v-if="showDot" class="pulse-dot-wrapper">
        <div class="pulse-dot"></div>
      </div>
      <template v-else>
        <div v-if="isLoggedIn" class="welcome-text">
          Welcome back!
          <div class="user-info">
            <div v-if="user">{{ user }}</div>
            <div v-else class="pulse-dot"></div>
          </div>
          <button class="logout-btn" @click="logout">Sign out</button>
        </div>
        <form v-else @submit.prevent="login">
          <div class="form-group">
            <label for="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              v-model="email"
              required
            />
          </div>
          <div class="form-group">
            <label for="password">Password:</label>
            <input
              type="password"
              id="password"
              name="password"
              v-model="password"
              required
            />
          </div>
          <button type="submit">Sign in</button>
          <div v-if="error" class="error">{{ error }}</div>
          <div v-if="logoutError" class="error">Sign out with errors</div>
        </form>
      </template>
    </div>
  </div>
</template>
<style scoped>
.user-info {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 27px auto 50px;
  height: 50px;
  font-size: 1.9rem;
  color: #333;
  font-weight: 700;
}
.error {
  color: #e41a2f;
  text-align: center;
  margin-top: 12px;
  font-size: 0.8rem;
}
.login {
  max-width: 350px;
  margin: 40px auto;
  background: #fff;
  padding: 32px 24px 24px 24px;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
}
.pulse-dot-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
}
.pulse-dot {
  width: 32px;
  height: 32px;
  background: #e41a2f;
  border-radius: 50%;
  box-shadow: 0 0 0 rgba(228, 26, 47, 0.7);
  animation: pulse 1s infinite;
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(228, 26, 47, 0.7);
  }
  70% {
    box-shadow: 0 0 0 20px rgba(228, 26, 47, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(228, 26, 47, 0);
  }
}
.welcome-text {
  text-align: center;
  font-size: 1.5rem;
  color: #e41a2f;
  margin: 40px 0;
}
.login form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.form-group {
  display: flex;
  flex-direction: column;
}
.form-group label {
  margin-bottom: 6px;
  font-weight: 500;
  color: #333;
}
.form-group input {
  padding: 10px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s;
}
.form-group input:focus {
  border-color: #e41a2f;
  outline: none;
}
.login button[type="submit"],
.logout-btn {
  padding: 12px;
  background: linear-gradient(135deg, #770d0e 0%, #e41a2f 75%);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 120, 215, 0.08);
  transition: background 0.2s;
  width: 75%;
  margin: 0 auto;
}
.login button[type="submit"]:hover {
  background: linear-gradient(155deg, #770d0e 0%, #e41a2f 75%);
}
</style>
<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import HelloWorld from "@/components/HelloWorld.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    HelloWorld,
  },
  setup() {
    const showDot = ref(true);
    const isLoggedIn = ref(false);
    const email = ref("");
    const user = ref(localStorage.getItem("user") || "");
    const password = ref("");
    const error = ref("");
    const logoutError = ref(false);
    const logout = async () => {
      logoutError.value = false;
      const token = localStorage.getItem("token");
      if (!token) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        user.value = "";
        isLoggedIn.value = false;
        return;
      }
      try {
        const response = await fetch("https://fireads.org/app/logout", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        user.value = "";
        isLoggedIn.value = false;
        if (response.status !== 200) {
          logoutError.value = true;
        }
      } catch (err) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        user.value = "";
        isLoggedIn.value = false;
        logoutError.value = true;
      }
    };

    const login = async () => {
      error.value = "";
      // if (window.location.href == "http://192.168.0.157:8080/") {
      //   // FAKE LOGIN
      //   localStorage.setItem("token", "fake-token");
      //   localStorage.setItem("user", email.value);
      //   user.value = email.value;
      //   isLoggedIn.value = true;
      //   return;
      // }
      try {
        const response = await fetch("https://fireads.org/app/login", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            email: email.value,
            password: password.value,
          }),
        });
        if (response.status === 200) {
          const data = await response.json();
          if (data.message && data.message.token) {
            localStorage.setItem("token", data.message.token);
            isLoggedIn.value = true;
            checkSession();
          } else {
            error.value = data.message || "Brak tokena w odpowiedzi.";
          }
        } else {
          error.value = "Błąd logowania: " + response.status;
        }
      } catch (err: any) {
        error.value = "Błąd logowania: " + err.message;
      }
    };

    const checkSession = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        isLoggedIn.value = false;
        return;
      }
      try {
        const response = await fetch("https://fireads.org/app/verify-token", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          const data = await response.json();
          if (data.user) {
            localStorage.setItem("user", JSON.stringify(data.user.name));
            user.value = `${data.user.name}`;
          }
          isLoggedIn.value = true;
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          user.value = "";
          isLoggedIn.value = false;
        }
      } catch (err) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        user.value = "";
        isLoggedIn.value = false;
      }
    };

    onMounted(() => {
      (async () => {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await checkSession();
        showDot.value = false;
      })();
    });

    return {
      showDot,
      isLoggedIn,
      email,
      password,
      error,
      login,
      logout,
      logoutError,
      checkSession,
      user,
    };
  },
});
</script>
